module.exports = __webpack_public_path__ + "img/purchase-icon-dark.b3361781.svg";